"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_react_data_tools_1 = require("@progress/kendo-react-data-tools");
/** The attribute required by the Grid selection on Grid `tr` elements. */
exports.GRID_ROW_INDEX_ATTRIBUTE = kendo_react_data_tools_1.TABLE_ROW_INDEX_ATTRIBUTE;
/** The attribute required by the Grid selection on Grid `td` elements. */
exports.GRID_COL_INDEX_ATTRIBUTE = kendo_react_data_tools_1.TABLE_COL_INDEX_ATTRIBUTE;
/** Attribute which disable selection start from this element. */
exports.GRID_PREVENT_SELECTION_ELEMENT = kendo_react_data_tools_1.TABLE_PREVENT_SELECTION_ELEMENT;
//# sourceMappingURL=index.js.map